import {
  PAGE_SIZE_OPTIONS,
  type PageSizeOption,
} from '../constants/permissions.ts';

interface PageSizeSelectProps {
  value: PageSizeOption;
  onChange: (size: PageSizeOption) => void;
}

/**
 * 페이지당 행 개수 선택 (요구사항: row 개수 조작 편의).
 * 변경 시 1페이지로 리셋되는 처리는 useBoardQueryState.setSize 가 담당.
 */
export function PageSizeSelect({ value, onChange }: PageSizeSelectProps) {
  return <label className="flex items-center gap-2 text-[13px] text-neutral-950/60 dark:text-white/60">
    <span>페이지당</span>
    <select
      value={value}
      onChange={(e) => onChange(Number(e.target.value) as PageSizeOption)}
      className="rounded-lg border border-black/15 dark:border-white/15 bg-white dark:bg-dark-card px-2.5 py-1.5 text-[13px] font-medium text-neutral-900 dark:text-neutral-100 outline-none transition-colors focus:border-neutral-950"
    >
      {PAGE_SIZE_OPTIONS.map((opt) => (
        <option key={opt} value={opt}>
          {opt}개
        </option>
      ))}
    </select>
  </label>
}
